import { determineDataSource } from "../DataStores/DataSource";
import type BaseRepository from "./BaseRepository";
import { type BaseSearchableRepository } from "./BaseSearchableRepository";

export interface LocalDatabaseEnterprise {
    auth: string;
    id: string;
    name: string;
}

export type BaseEnterpriseRepository =
    BaseRepository<LocalDatabaseEnterprise> &
    BaseSearchableRepository<LocalDatabaseEnterprise>;

export const getEnterpriseAuthToken = async (id: string): Promise<string> => {
    const source = await determineDataSource();
    const enterprise = await source.enterprises.get(id);

    return enterprise.auth;
};
